import {AfterViewInit, Component, Input, OnDestroy, OnInit, ViewChild} from '@angular/core';
import {MatPaginator, PageEvent} from "@angular/material/paginator";
import {ReplaySubject} from "rxjs";
import {OfwcaMeeting} from "../../../shared/interface/ofwca-meeting";
import {MeetingService} from "../../../shared/services/meeting.service";
import {delay, distinctUntilChanged, first, takeUntil, tap} from "rxjs/operators";
import {CountedAndPaginated} from "../../../shared/interface/response/counted-and-paginated";
import {UserPermissions} from "../../../shared/interface/user-permissions";
import {MatSnackBar} from "@angular/material/snack-bar";
import {MatDialog} from "@angular/material/dialog";
import {AuthService} from "../../../shared/services/auth.service";
import {ActivatedRoute, Router} from "@angular/router";
import {FilterService} from "../../../shared/services/filter.service";
import {select, Store} from "@ngrx/store";
import {StoreRootState} from "../../../shared/ngrx/reducers";
import {NgForm} from "@angular/forms";
import {getCurrentRouteState} from "../../../shared/ngrx/selector";
import {RouterStateUrl} from "../../../shared/ngrx/route-serializer";
import {Ofwca} from "../../../shared/interface/ofwca";
import {Uuid} from "../../../shared/interface/response/uuid";
import {JobResultDialogComponent} from "../../../shared/components/job-result-dialog/job-result-dialog.component";
import {HttpErrorResponse} from "@angular/common/http";
import {
  DICT_TYPE_MEETING_TYPE,
  DICT_TYPE_TEMPLATE_TYPE,
  DictService, MEETING_TYPE_ENTRANCE_EXAM, MEETING_TYPE_EXAM,
  TEMPLATE_TYPE_OFWCA_APPLICATION
} from "../../../shared/services/dict.service";

@Component({
  selector: 'app-ofwca-registered-list',
  templateUrl: './ofwca-registered-list.component.html',
  styleUrls: ['./ofwca-registered-list.component.scss']
})
export class OfwcaRegisteredListComponent implements  OnDestroy, AfterViewInit {
  @Input() typeKey?: string;
  @Input() name?: string;
  @ViewChild('filtersForm') filtersForm: NgForm;
  @ViewChild(MatPaginator) paginator: MatPaginator;

  initialFilters: any;
  ofwcaMeetings: OfwcaMeeting[] = [];
  totalData = 0;
  displayedColumns: string[] = ['fullName',  'rau',
    'insuranceCompany',  'startsAt', 'meeting', 'examType', 'status', 'passedExam', 'assetsRegional' ];
  userPermissions: ReplaySubject<UserPermissions>;
  readonly MEETING_TYPE_EXAM = MEETING_TYPE_EXAM;
  readonly MEETING_TYPE_ENTRANCE_EXAM = MEETING_TYPE_ENTRANCE_EXAM;

  private destroyed$: ReplaySubject<boolean> = new ReplaySubject<boolean>(1);

  constructor(
    private meetingService: MeetingService,
    private snack: MatSnackBar,
    private dialog: MatDialog,
    private auth: AuthService,
    private activatedRoute: ActivatedRoute,
    private filterService: FilterService,
    private store: Store<StoreRootState>,
    private router: Router,
    private dictService: DictService,
  ) {
    this.userPermissions = auth.getUserPermissions();
    this.meetingService.getOfwcaMeetingListSubject()
      .pipe(
        takeUntil(this.destroyed$),
        tap((e: CountedAndPaginated<OfwcaMeeting>) => {
          this.ofwcaMeetings = e.items;
          this.totalData = e.pagination.total;
        })
      ).subscribe();
    this.parseFilters();
  }

  ngOnDestroy(): void {
    this.destroyed$.next(true);
    this.destroyed$.complete();
  }


  ngAfterViewInit(): void {
    this.activatedRoute.data
      .pipe(
        delay(0),
        first()
      )
      .subscribe((data: any) => {
        this.typeKey = this.typeKey ?? data.typeKey ?? null;
        this.name = this.name ?? data.name ?? 'Egzaminy i szkolenia';
        this.loadListData();
      });

    this.paginator.page
      .pipe(
        takeUntil(this.destroyed$)
      ).subscribe((event: PageEvent) => {
      this.router.navigate([this.activatedRoute.snapshot.routeConfig.path, this.filterService.parseFiltersToQueryParams({
        page: event.pageIndex,
        pageSize: event.pageSize,
        ...this.filtersForm.value
      })]);
    });

    this.store
      .pipe(
        select(getCurrentRouteState),
        delay(0),
        distinctUntilChanged((prev: RouterStateUrl, curr: RouterStateUrl) => prev.url === curr.url),
        takeUntil(this.destroyed$),
      )
      .subscribe((state: RouterStateUrl) => {
        this.parseFilters(state.params);
        this.paginator.pageIndex = state.params.page;
        this.paginator.pageSize = state.params.pageSize;
        this.loadListData();
      })
    ;
  }
  loadListData(): void {
    this.meetingService.getOfwcaMeetingsList(this.paginator.pageIndex, this.paginator.pageSize, this.buildFilters());
  }

  parseFilters(filters?: any): void {
    this.initialFilters = this.filterService.parseFiltersFromQueryParams({
      type: 'int',
      insuranceCompany: 'int',
      gte$startsAt: 'date',
      lte$endsAt: 'date',
      status: 'int',
      examType: 'int',
      place: 'int',
      ofwca: 'string',
    }, filters);
  }

  resetFilters(): void {
    this.filtersForm.resetForm();
    this.router.navigate([this.activatedRoute.snapshot.routeConfig.path, {
      page: 0,
      pageSize: this.paginator.pageSize,
    }]);
  }

  buildFilters(): any {
    const filters = {...this.initialFilters};

    if (null !== this.typeKey) {
      filters.typeKey = this.typeKey;
    }

    return filters;
  }

  downloadReport(): void {
    this.meetingService.downloadOfwcaMeetingReport(this.buildFilters())
      .subscribe((response: Uuid) => {
        this.dialog.open(JobResultDialogComponent, {
          disableClose: true,
          width: '500px',
          data: {jobId: response.uuid, showProgress: false},
        });
      }, (error: HttpErrorResponse) => {
        this.snack.open('Przy generowaniu raportu wystąpił błąd', error.status.toString(), {duration: 2000});
      });
  }

  filter(): void {
    this.router.navigate([this.activatedRoute.snapshot.routeConfig.path, this.filterService.parseFiltersToQueryParams({
      page: 0,
      pageSize: this.paginator.pageSize,
      ...this.filtersForm.value,
    })]);
  }
}
